/**
 * After a deploy, a tab opened on the previous build asks for page files that no longer exist ("Failed to fetch
 * dynamically imported module"). Reloading once picks up the new build; the guard stops a reload loop when the
 * failure has another cause (e.g. offline).
 */
const KEY = 'ea:stale-build-reload';

export const isStaleBuildError = (e: unknown) =>
  e instanceof Error && /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Unable to preload CSS/i.test(e.message);

/** Reloads the page unless it was already reloaded for this in the last minute. Returns true when reloading. */
export function reloadForNewBuild(): boolean {
  try {
    const last = Number(sessionStorage.getItem(KEY) ?? 0);
    if (Date.now() - last < 60_000) return false;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    /* storage unavailable: reload anyway */
  }
  window.location.reload();
  return true;
}
